angular.module('trainerWebApp.resources').factory('feedbackResource', ['$resource', '$location', 'errorHandler',
  function($resource, $location, errorHandler) {

    var FeedbackResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/feedback');

    FeedbackResource.prototype.send = function send(message, location, resultCb, errorCb) {
      return FeedbackResource.save({},
        {
          text: message,
          location: location,
          browser: BrowserDetect.browser + ' ' + BrowserDetect.version + ' on ' + BrowserDetect.OS,
          url: $location.absUrl()
        }, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    return new FeedbackResource;
  }
]);
